import { Divider, SIZE, Stack } from '@quinyx/ui';

import QuinyxLicense from './QuinyxLicense';
import ScriveLicenses from './ScriveLicenses';

type LicenseProps = {
  domainId: string;
  isDisabled?: boolean;
};

const LicenseForm = ({ domainId, isDisabled = false }: LicenseProps) => {
  return (
    <Stack spacing={SIZE.M}>
      <QuinyxLicense domainId={domainId} isDisabled={isDisabled} />
      <Divider />
      <ScriveLicenses domainId={domainId} isDisabled={isDisabled} />
    </Stack>
  );
};

export default LicenseForm;
